import { render, staticRenderFns } from "./HeaderCompanySelector.vue?vue&type=template&id=672c5bd5&"
import script from "./HeaderCompanySelector.vue?vue&type=script&lang=js&"
export * from "./HeaderCompanySelector.vue?vue&type=script&lang=js&"
import style0 from "./HeaderCompanySelector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports